import createReactComponent from '../createReactComponent';
export default createReactComponent('rail-symbol', 'RailSymbol', [["path",{"d":"M4 15.375h16M4 8.625h16M16 20l-8-4.625 8-6.75L8 4","key":"svg-0"}]]);